import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { ApiError, hasLiveApi } from '@/api/client'
import {
  getVARBets,
  searchIBLogs,
  toInvalidBetsResult,
} from '@/api/map/invalidBetLogs'
import type { InvalidBetsQuery, InvalidBetsResult } from './invalidBetsTypes'

/** Empty page when demo / offline — no invented invalid / VAR rows. */
export function emptyInvalidBets(query: InvalidBetsQuery): InvalidBetsResult {
  const pageSize = Math.max(1, query.pageSize ?? DEFAULT_PAGE_SIZE)
  const page = Math.max(1, query.page ?? 1)
  return {
    rows: [],
    total: 0,
    page,
    pageSize,
    tab: query.tab,
  }
}

/**
 * Live Keycloak → hierarchy `getVARBets` / `searchIBLogs`.
 * Demo / no live API → empty (never invent log rows).
 */
export async function loadInvalidBets(
  query: InvalidBetsQuery,
): Promise<InvalidBetsResult> {
  if (!hasLiveApi()) return emptyInvalidBets(query)

  const members = (query.members ?? [])
    .map((name) => name.trim())
    .filter(Boolean)

  const body = {
    page: query.page ?? 1,
    pageSize: query.pageSize ?? DEFAULT_PAGE_SIZE,
    fromDate: query.fromDate,
    toDate: query.toDate,
    playerName: members.length > 0 ? members : undefined,
  }

  try {
    const live =
      query.tab === 'var-bet' ? await getVARBets(body) : await searchIBLogs(body)
    if (!live.value) return emptyInvalidBets(query)
    return toInvalidBetsResult(live, query)
  } catch (err) {
    const status = err instanceof ApiError ? err.status : 0
    const op = query.tab === 'var-bet' ? 'getVARBets' : 'searchIBLogs'
    console.warn(`[invalid-bets] hierarchy ${op} unavailable`, err)
    if (status === 404) {
      console.warn(
        `[invalid-bets] Agent-API ${op} route is not deployed on this hierarchy yet.`,
      )
    }
    return emptyInvalidBets(query)
  }
}
